import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = 'https://db.ab-civil.com';
export const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzU3OTU4MTU3LCJleHAiOjIwNzMzMTgxNTd9.wMFIipTSYzcCZWbzItsH2oOBNy1XZiBCFmW7Jx3Fws8';

// Configuration with manual refresh control to prevent conflicts
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: false, // Disabled to prevent conflicts with manual refresh in AuthContext
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  }
});
